import { Tabs, Tab } from '@mui/material'
import { Box } from '@mui/system'
import { SyntheticEvent, useState } from 'react'
import { faFaceSmile } from "@fortawesome/pro-light-svg-icons"
import { TabPanel } from '../../../../../shared/components/tabs/tabPanel'
import { RatingsOverviewTab } from '../components/RatingsOverviewTab'
import { AllRatingsTab } from '../components/AllRatingsTab'
import { useAppLocalization } from '../../../../localization/components/AppLocalizationProvider'
import { RatingCommentsTab } from '../components/RatingCommentsTab'
import { PageHeader } from '../../../../../shared/components/pageHeader/PageHeader'
import { Page } from '../../../../../shared/components/pageHeader/PageHeaderApi'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LocalizedStrict } from '../../../../localization/components/AppLocalized'
import { Breadcrumb, BreadcrumbLink, StandardBreadcrumbs } from '../../../../../shared/components/links/StandardBreadcrumbs'
import { MERCHANT_REPORTS_ROUTE } from '../../../../../constants/routes'


export function Survey() {
    const [value, setValue] = useState(0)
    const { l10n } = useAppLocalization()

    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    return (
        <>
            <LocalizedStrict id="survey-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.USER_SURVEY}
                    title="Survey"
                    icon={<FontAwesomeIcon icon={faFaceSmile}/>}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_REPORTS_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-survey">
                            <Breadcrumb>Survey</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: "2rem" }}>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab value={0} label={l10n.getString("survey-tab-overview")} wrapped sx={{ textTransform: 'none' }} />
                        <Tab value={1} label={l10n.getString("survey-tab-ratings")} wrapped sx={{ textTransform: 'none' }} />
                        <Tab value={2} label={l10n.getString("survey-tab-comment")} wrapped sx={{ textTransform: 'none' }} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <RatingsOverviewTab />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <AllRatingsTab />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <RatingCommentsTab />
                </TabPanel>
            </Box >
        </>
    )
}
